<template>
  <div>shop dashboard {{ $route.params.id }}</div>
</template>

<script>
export default {
  name: "ShopDashboard",
};
</script>
